import { createTheme } from "@mantine/core";

// Single source of truth for the Mantine theme (R2). Add all custom
// tokens here; never call createTheme() in individual SPA App.tsx files.
export const theme = createTheme({});
